<template>
  <ob-admin-section
    type="access"
    :xlsx="false"
    :add="false"
    :edit="false"
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed">

    <template slot="section-title">Sectiune Acces Applicatie</template>

    <template slot="toolbar-title">Baza de date Acces Applicatie</template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'

export default {
  name: 'access',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog
  },
  data: () => ({
    type: 'access',
    fab: null,
    confirm: {
      dialog: false,
      callback: null
    },
    selected: []
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    token () {
      return this.$store.getters['token']
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    }
  },
  methods: {
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    }
  },
  created () {
    this.$store.dispatch(`${this.type}/setEventWatchers`)
    this.$store.dispatch(`${this.type}/fetchHeaders`)
    this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
